/* Native Shopify variant IDs are submitted to this store's own cart. */
if (!customElements.get('chill-collar-product')) {
  customElements.define('chill-collar-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      const form = this.querySelector('form');
      const update = () => {
        const choice = this.querySelector('input[name="id"]:checked');
        if (!choice) return;
        this.querySelector('[data-price]').textContent = choice.dataset.price;
        this.querySelector('[data-included]').textContent = choice.dataset.contents;
        const saving = this.querySelector('[data-saving]');
        saving.textContent = choice.dataset.saving ? `Save ${choice.dataset.saving}` : '';
        saving.hidden = !choice.dataset.saving;
        this.querySelector('[data-submit]').disabled = choice.disabled;
        this.querySelector('[data-submit]').textContent = choice.disabled ? 'Sold out' : 'Add to cart';
        const result = this.querySelector('[data-preview-result]');
        if (result) result.textContent = '';
      };
      this.addEventListener('change', update);
      this.querySelectorAll('[data-photo]').forEach(button => {
        button.addEventListener('click', () => {
          const main = this.querySelector('[data-main-photo]');
          main.src = button.dataset.photo;
          main.alt = button.dataset.alt;
          this.querySelectorAll('[data-photo]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        });
      });
      // Only the offline renderer adds this attribute. It never creates a cart.
      if (this.hasAttribute('data-preview')) {
        form.addEventListener('submit', event => {
          event.preventDefault();
          const choice = this.querySelector('input[name="id"]:checked');
          this.querySelector('[data-preview-result]').textContent = `Preview selection: ${choice.dataset.contents}. Subtotal ${choice.dataset.price} AUD. The finished product will use ${this.dataset.checkout}. No order or payment has been created.`;
        });
      }
      update();
    }
  });
}
